// Mirror of functions/_lib/monitoring-policy.ts for the browser bundle (the SPA
// and the Worker compile separately). Keep the two lists identical. The server
// enforces the rule; this file only decides what the client is shown.
export const CLIENT_MONITORING_PROVIDERS = ['my_free_score_now'] as const;
export type ClientMonitoringProvider = (typeof CLIENT_MONITORING_PROVIDERS)[number];
export const MONITORING_LABEL: Record<string, string> = {
  my_free_score_now: 'MyFreeScoreNow',
  smart_credit: 'SmartCredit',
};
export function isClientMonitoringProvider(v: unknown): v is ClientMonitoringProvider {
  return typeof v === 'string' && (CLIENT_MONITORING_PROVIDERS as readonly string[]).includes(v);
}
